import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    cardStyle: {
      width: "433px",
      borderRadius: "12px !important",
      padding: "24px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      border: `1px solid ${theme.palette.background.gray_200}`,
    },
    cardHeading: {
      borderRadius: "12px 12px 0 0 !important",
    },
    titleHeading: {
      paddingBottom: "20px",
      borderBottom: `1px solid ${theme.palette.border.gray_200}`,
      marginBottom: "16px",
    },
    contentWrapper: {
      "& *": {
        borderRadius: "8px",
      },
    },
    summaryFieldWrapper: {
      display: "flex",
      flexDirection: "column",

      gap: "16px",
    },
    summaryField: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      flexBasis: "48%",
    },
    socialIcons: {
      display: "flex",
      gap: "8px",
    },
    languageDetails: {
      display: "flex",
      gap: "4px",
    },
    agentContainer: {
      display: "flex",
      width: "100%",
      gap: "16px",
      alignItems: "center",
    },
    clientDetailsSkeleton: {
      display: "flex",
      gap: "8px",
    },
    profileField: {
      display: "flex",
      gap: "8px",
    },
    clientData: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    summarySection: {
      backgroundColor: theme.palette.utility.utility_gray_50,
      padding: "24px",
      borderRadius: "0 0 12px 12px",
      width: "433px",
      border: `1px solid ${theme.palette.border.gray_200}`,
      borderTop: "none",
    },
    unitCard: {
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.border.secondary}`,
      borderRadius: "12px",
      color: theme.palette.text.primary,
      display: "flex",
      flexDirection: "column",
      width: "314px",
      cursor: "pointer",
    },
    imageWrapper: {
      width: "100%",
      height: "240px",
      position: "relative",
    },
    unitImage: {
      width: "100%",
      height: "100%",
      backgroundSize: "cover",
      backgroundPosition: "center",
      borderRadius: "12px 12px 0 0",
    },
    details: {
      padding: "20px 16px",
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    header: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    body: {
      padding: "12px 0 0",
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    unitDetails: {
      display: "flex",
      gap: "8px",
      flexWrap: "wrap",
    },
    invoiceContainer: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      alignItems: "center",
      border: `1px solid ${theme.palette.background.gray_200}`,
      backgroundColor: theme.palette.background.paper,
      borderRadius: "12px",
      padding: "20px",
    },
    invoiceField: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      width: "100%",
    },
  };
});
